import { Box } from '@mui/material'
import type { ReactNode } from 'react'

import { SEPARATOR_LEFTS } from './HeatingFundingSection.styles'

/** Wraps a block of grid rows and draws the column separators only within it */
const SeparatedBlock = ({ children }: { children: ReactNode }) => (
  <Box sx={{ position: 'relative' }}>
    {SEPARATOR_LEFTS.map(left => (
      <Box
        key={left}
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left,
          width: '1px',
          backgroundColor: '#ECEDEF',
        }}
      />
    ))}
    {children}
  </Box>
)

export default SeparatedBlock
